import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../../api';
import './ForgotPassword.css';
import 'font-awesome/css/font-awesome.min.css';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);

        try {
            await apiClient.post('/password/forgot', { email });
            setSubmitted(true);
        } catch (err) {
            if (!err.response) {
                setError('Error de conexión. Inténtalo de nuevo más tarde.');
            } else {
                setError('Hubo un problema procesando tu solicitud.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="forgot-page-wrapper">
            <div className="auth-card">
                {!submitted ? (
                    <>
                        <div className="auth-header">
                            <h1>Recuperar Contraseña</h1>
                            <p className="auth-subtitle">
                                Introduce tu correo y te enviaremos las instrucciones para restablecer tu clave.
                            </p>
                        </div>

                        {error && (
                            <div className="error-banner">
                                <i className="fa fa-exclamation-circle"></i> {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit} className="auth-form">
                            <div className="form-group">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="ejemplo@correo.com"
                                    required
                                    disabled={isLoading}
                                />
                            </div>

                            <button
                                type="submit"
                                className="action-button"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <span><i className="fa fa-spinner fa-spin"></i> Enviando...</span>
                                ) : (
                                    "Enviar Enlace"
                                )}
                            </button>
                        </form>

                        <div className="back-link">
                            <Link to="/">
                                <i className="fa fa-arrow-left"></i> Volver al inicio de sesión
                            </Link>
                        </div>
                    </>
                ) : (
                    <div className="success-state">
                        <div className="success-icon">
                            <i className="fa fa-envelope-o"></i>
                        </div>
                        <div className="auth-header">
                            <h1>¡Correo Enviado!</h1>
                        </div>
                        <div className="success-text">
                            Si la cuenta <strong>{email}</strong> existe, recibirás un enlace en unos minutos. Revisa tu bandeja de spam.
                        </div>

                        <div className="back-link" style={{ marginTop: '24px' }}>
                            <Link to="/" className="action-button secondary-button" >
                                ← Volver al inicio
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ForgotPassword;